<div class="bmc-import-parent">
    <div class="bmc-import-header">
      <h3 class="bmc-import-header__text"> {{ 'SYNC_FILES.IMPORT_ENTITY_VALUES' | translate}}</h3>
      <div class="bmc-import-header__close" (click)="closeModal()">
        <svg class="bmc-import-header__close__icon">
          <use href="#icon-close"></use>
        </svg>
      </div>
    </div>
    <div class="bmc-import-content" [ngClass]="{'bmc-import-content_loaded': !isLoading}">
      <div *ngIf="status !=='error' && status !=='nodata'">
        <div class="bmc-syncdata-import-step0">
          <div *ngIf="!isLoading">
            <h5 class="bmc-syncdata-import-step0__title">{{ 'SYNC_FILES.SELECT_FILE_TO_IMPORT' | translate}}</h5>
            <div class="bmc-syncdata-import-step0__file-selection">
              <bzg-input type="text" class="bmc-syncdata-import-step0__file-selection__file-path" disabled="true" [(ngModel)]="FilePath"
                placeholder="{{ ('SYNC_FILES.FILE_NAME' | translate)}}"></bzg-input>
              <bzg-button-primary class="bmc-syncdata-import-step0__browse" type="button" (click)="addFiles()">{{
                'SYNC_FILES.BUTTON_BROWSE' | translate}}</bzg-button-primary>
              <input #fileUpload [id]="'import-file-input'" type="file" (change)="onFilesAdded()" [hidden]="true"
              accept=".bfex" filters=".bfex">            
            </div>
          </div>
          <div *ngIf="isLoading" class="bmc-sync-data__loader">
            <bz-loading *ngIf="messageStatus==='loading'" [message]="'SYNC_FILES.LOADING'"></bz-loading>    
            <bz-loading *ngIf="messageStatus==='importing'" [message]="'SYNC_FILES.IMPORT_FILE'"></bz-loading>           
          </div>
        </div>
      </div>
      <div *ngIf="status =='error'">
        <biz-sync-files-error-table [errorData]="filesWithError" [status]="import"></biz-sync-files-error-table>
      </div>
    </div>
    <div class="bmc-import-footer">
      <div class="bmc-import-footer__right-container">
        <bzg-button-primary *ngIf="status !=='error'" [disabled]="!FilePath || isLoading" type="button" class="btnFooterBlue"
          (click)="onImport()">{{'SYNC_FILES.IMPORT' | translate}}</bzg-button-primary>
        <bzg-button-primary *ngIf="status =='error'" type="button" (click)="closeModal()">{{'SYNC_FILES.CLOSE' |
          translate}}</bzg-button-primary>
      </div>
    </div>
  </div>